{
	"myShipments": "My account",
	"attentionRegistrationRequired": "Attention, this is a new system that requires a login with an e-certificate or registration.",
	"companyLogin": "for company login.",
	"VERIFY_SOCIALID": {
		"header": "Verify Social id",
		"paragraph": "Please insert the email you used in the registration.",
		"success-header": "Successfully verified social id",
		"success-paragraph": "You can now login and use the full features",
		"error-paragraph": "Error verifying social id - we're looking into this"
	},
	"VERIFY_EMAIL": {
		"header": "Verify email",
		"paragraph": "Please insert the email you used in the registration.",
		"success-header": "Successfully verified email",
		"success-paragraph": "",
		"error-paragraph": "Error verifying email - we're looking into this"
	},
	"RESET_PASSWORD": {
		"header": "Reset password",
		"email": "Email",
		"newPassword": "New password",
		"newPasswordAgain": "New password again",
		"success-header": "Password reset!",
		"success-paragraph": "You can now login",
		"error-paragraph": "Error resetting password - we're looking into this",
		"error-identical": "The password have to be identical"
	},
	"onboarding": {
		"profile": {
			"bubbleHeading": "Profile",
			"bubbleText": "Fill out necessary information",
			"infoText": "Please enter your mobile phone number so we can send you text messages with info regarding your deliveries",
			"emailVerified": "Email is verified",
			"emailNotVerified": "Email is not verified"
		},
		"payment": {
			"bubbleHeading": "Payments",
			"bubbleText": "Choose your payment method",
			"heading": "Payments",
			"infoText": "Simplify your life by entering your credit card and register for automatic payments. Then we can process your deliveries faster.",
			"automaticPayments": "Sign up for automatic payments for faster processing of your deliveries and lower fees.",
			"automaticPaymentsCheckbox": "Select automatic payments"
		},
		"delivery": {
			"bubbleHeading": "Delivery",
			"bubbleText": "Select where you want your shipments delivered",
			"heading": "Delivery location",
			"infoText": "Pick a delivery location that best fits your needs and daily schedule."
		},
		"terms": {
			"bubbleHeading": "Terms of use",
			"bubbleText": "Agree to the terms of use",
			"heading": "Terms of use",
			"terms1": "To be able to use your account you must agree to our terms of use. When that is over and done with you can make most of all the your account's benefits.",
			"terms2": "terms of use",
			"terms3": ". When that is over and done with you can make most of all the my account benefits.",
			"termsCheckbox": "Agree to terms of use"
		},
		"next": "Next step",
		"skip": "Skip",
		"complete": "Confirm"
	},
	"navigation": {
		"welcome": "Welcome",
		"shipments": "Shipments",
		"shipment": "Shipment",
		"settings": "My information",
		"recipients": "Recipients",
		"logout": "Logout",
		"refund": "Refund",
		"register-shipment": "Register shipment"
	},
	"notifications": "Notifications",
	"noNotifications": "No notifications",
	"page-login": {
		"appPromotion": "New app has been released for both Android and Apple",
		"download": "Download",
		"fromGooglePlay": "from Google Play",
		"fromAppStore": "from App Store",
		"electronicId": "Electronic id",
		"electronicIdHeading": "Phone number",
		"electronicIdPlaceholder": "Enter phone number",
		"password": "Password",
		"retypePassword": "Repeat password",
		"enterEmail": "Enter email address",
		"enterPassword": "Password",
		"logIn": "Log in",
		"forgot-password": "Forgot password?",
		"forgot-password-instructions": "Get instructions to reset your password sent to your email. Attention, this is a new system and if you haven't logged in before you need to do so with e-certificate or register a new account.",
		"register": "Register",
		"registrationIntro": "Please fill out and accept the following information",
		"iAccept": "I accept terms",
		"posturTerms": "Pósturinn's terms",
		"registerButton": "Create an account",
		"error": "Failed to login, please try again",
		"forgotPasswordIntro": "Enter your email and get instructions to reset your password",
		"signupSuccessHeading": "Successful registration",
		"signupSuccessHeadingSub": "Please activate the account and connect to your social security ID.",
		"signupSuccessStep1": "1. Open your inbox and confirm your email address.",
		"signupSuccessStep2": "2. After the email address is confirmed you need to confirm your social security ID via your online bank.",
		"signupSuccessStep3": "3. Once these two are confirmed you can log in with your email address and password.",
		"socialIdVerificationMissing": "Identification number has not been confirmed, please open your e-docs in your icelandic online bank, and confirm your identification number from Pósturinn.",
		"emailVerificationMissing": "Email has not been verified, please open your inbox and verify your email through the message from Pósturinn",
		"invalidGrant": "User name or password incorrect",
		"loginFailed": "Login failed.",
		"phoneNumberNotCorrect": "Phone number is incorrect",
		"user_fyrtaekjasidur": " ",
		"user_fyrtaekjasidur1": "This is a username for ",
		"user_fyrtaekjasidur2": "Please use an electronic ID or username for your social security number if you plan to log in ",
		"user_fyrtaekjasidurLinkFyritaekjasidur": "Fyrirtækjasíður.  ",
		"user_fyrtaekjasidurLinkMinarSidur": "My account. ",
		"audkenni": {
			"audkenniApp": "Auðkenniapp",
			"verifyText": "Verify the authentication <0>only if</0> the code below is the same as the code in your phone",
			"placeholder": "Enter your Social ID number",
			"timeout": "Authentication timed out"
		}
	},
	"page-overview": {
		"incomingShipments": "Incoming",
		"outgoingShipments": "Outgoing",
		"deliveredShipments": "Delivered shipments",
		"noShipmentsFound": "No shipments found",
		"noShipmentFound": "No shipment found",
		"deliveryLocation": "Delivery location",
		"homeDelivery": "Home delivered",
		"addReceipt": "Add receipt",
		"openLocker": "Open locker",
		"inTransit": "In transit",
		"delivered": "Delivered",
		"addDocuments": "Add documents",
		"missingCustomsInformation": "Missing customs information",
		"missingDocuments": "Missing documents",
		"isGift": "Is a gift",
		"payFor": "Pay for ",
		"customsInfoFor": "Add customs information for ",
		"barcode": "Barcode",
		"qrInstruction": "Scan the QR code or type in the PIN.",
		"multiPartQRCode": "Scant the QR code or type in PIN 1 and confirm, then type in PIN 2 and confirm.",
		"dropoffFile": "Attachment",
		"dropOff": "Bring your shipment to us",
		"dropoffAtPostoffice": "Bring your shipment to a post office",
		"dropoffAtPostofficeStatus": "View post office opening hours",
		"dropoffAtPostbox": "Drop off at a postbox",
		"dropoffAtPostboxCondition": "*In order to be eligible to drop off at a postbox you must have a valid payment option and automatic payments active -",
		"dropoffAtPostboxAutomaticCondition": "*In order to be eligible to drop off at a postbox you must have automatic payments enabled -",
		"dropoffAtPostboxStatus": "See status of drop off locations",
		"dropoffStatuses": "Drop off locations statuses",
		"dropOffAtLocation": "Bring the barcode to the post box, printed or on your phone.",
		"dropOffAtPostoffice": "You have now registered your shipment and can drop it off at the post office.",
		"barcodeInfo": "The barcode is used to open the post box and/or print labels",
		"barcodeInfoPostoffice": "Use the barcode below when you drop off your shipment at the post office.",
		"printLabelAtLocation": "Put the label on the parcel.",
		"printLabelAtPostoffice": "The label can be printed at the post office, but you can also print out the attachment below and attach it to the package.",
		"payment-card-missing": "Payment card missing.",
		"bring-the-barcode": "Bring the barcode to the post box, printed or on your phone.",
		"barcode-accessible": "Both in the app and on My account, you can find the barcode and shipping attachment.",
		"deleteShipment": "Are you sure you want to delete this shipment?",
		"showHidden": "Show hidden",
		"hideHidden": "Hide hidden",
		"hideShipmentModal": "Are you sure you want to hide the shipment?"
	},
	"page-settings": {
		"deliveryOptions": "Delivery options",
		"deliveryOptionsSubHeader": "Where do you want your shipment delivered?",
		"ruralInfo": "Please note, if you live in a rural area and want your package delivered to your home, please do not select any parcel pickup location unless you want to pick up at the post office or a póstbox parcel locker.",
		"chooseDeliveryOption": "Choose delivery option",
		"paymentOptions": "Payment cards",
		"addPaymentOption": "Add payment card",
		"deleteCard": "Delete card?",
		"default": "Default",
		"location": "Location",
		"zip": "Zip",
		"municipality": "Municipality",
		"openingHours": "Opening hours",
		"changeProfile": "Change my profile",
		"changeAddress": "Change address",
		"changeForMyself": "Change for myself",
		"changeFor": "Change for ",
		"changePassword": "Change password",
		"oldPassword": "Old password",
		"newPassword": "New password",
		"repeatNewPassword": "Repeat new password",
		"chooseRegion": "Choose region",
		"deliveryOptionSearch": "Search..",
		"automaticPaymentsInfo": "Processing gets quicker and you pay less!",
		"enableAutomaticPayments": "Enable automatic payments",
		"disableAutomaticPayments": "Disable automatic payments",
		"verifyMessage": "Verify following:",
		"verifyPhoneNumber": "Verify phone number",
		"verifyEmail": "Verify email",
		"verifyPhoneNumberMessage": "You will receive a SMS with a verification code. Please type in the code to verify your phone number.",
		"verifyEmailMessage": "We sent you an email with a verification link. Please click the link to complete the verification.",
		"verificationCode": "Verification code",
		"code": "Code",
		"verify": "Verify",
		"close": "Close",
		"clearDeliveryOption": "Clear",
		"verifyEmailSecureMessage": "We sent you an email with a verification code. Please type in the code to verify your email.",
		"verifyEmailForceHeader": "Verify email address",
		"verifyEmailForce": "Verify your email address to be able to use My account at Pósturinn, only users with verified email addresses can use My account",
		"phone-gsm-format": "Phone number must be a mobile number"
	},
	"page-recipients": {
		"info": "Stored recipients can be loaded in while registering shipments.",
		"addRecipient": "Add recipient",
		"editRecipient": "Edit recipient",
		"noRecipients": "No stored recipients found."
	},
	"status": {
		"AvailableForPickup": "Available for pickup",
		"AvailableForPickupAtParcelPoint": "Available for pickup",
		"AvailableForPickupAtPostBox": "Available for pickup",
		"AvailableForPickupAtPostOffice": "Available for pickup",
		"Cancelled": "Cancelled",
		"Delivered": "Delivered",
		"Error": "Error",
		"InProgress": "In progress",
		"InTransit": "In transit",
		"InvoiceReceived": "Invoice received",
		"OnHold": "On hold",
		"PreTransit": "Iceland Post is waiting for the package",
		"Unknown": "Unknown",
		"WaitingDropOff": "Waiting for dropoff",
		"CourierPickup": "Courier pickup",
		"DepartedFromSender": "Departed from sender",
		"InternationalShipmentArrivedInIceland": "International shipment arrived in iceland",
		"InternationalShipmentExpectedFromAbroad": "International shipment expected from abroad",
		"InTransitAbroad": "In transit abroad",
		"OutForHomeDelivery": "Out for home delivery",
		"ReturnedToSender": "Returned to sender",
		"UnsuccessfulHomeDelivery": "Unsuccessful home delivery"
	},
	"dropOffStatus": {
		"none": "No slots free",
		"low": "Almost no slots free",
		"medium": "Handful of open slots",
		"high": "Many free slots!"
	},
	"page-files": {},
	"amount": "Amount",
	"availableForPickup": "Available for pickup",
	"fetchDocument": "Fetch",
	"postbox": "Parcel locker",
	"filesConnectedToShipment": "Attachments",
	"paymentBreakdown": "Payment overview",
	"paymentInfoText1": "Information about fees related to import and tariff categories for Skatturinn (Iceland Revenue and Customs)  can be found ",
	"paymentInfoText2": "here",
	"paymentInfoText3": " and in the documents below, you can find a breakdown of fees.",
	"postboxInfo": "Póstbox parcel lockers are located in various key locations around the country and are open 24/7",
	"pakkaport": "Parcel point",
	"pakkaportInfo": "You pick up your shipments in a service area near you,  when you want.",
	"postoffice": "Post office",
	"postofficeInfo": "You pick up your deliveries at a post office of your choice.",
	"deliveryPointSearchPlaceholder": "Filter by name, postcode, address..",
	"undecided": "Undecided",
	"homeDelivery": "Home delivered",
	"postCode": "Postcode",
	"noDocuments": "There are no documents attached to this shipment",
	"unnamedFile": "Unnamed file",
	"addDocuments": "Add documents",
	"noTrackingEvents": "There are no tracking events for this shipment",
	"fullName-required": "Name is required",
	"socialId-required": "Social id is required",
	"socialId-min": "Social id is 10 digits",
	"companySSN": "You have a company identification number, please register on <0>fyrirtaekjasidur.posturinn.is</0>",
	"invalid-socialid": "We can't find your social id on record, try again",
	"backToLogin": "Go back to login page",
	"name": "Name",
	"fullName": "Full name",
	"automaticPayments": "Automatic payments",
	"cardholder": "Cardholder",
	"cardholderPlaceholder": "John Doe",
	"cardnumber": "Cardnumber",
	"cardnumberPlaceholder": "****************",
	"expiryDate": "Expiry date",
	"expiryDatePlaceholder": "**/**",
	"cvc": "CVC",
	"cvcPlaceholder": "***",
	"receipt": "Receipt",
	"shipments": "Shipments",
	"trackingNumber": "Tracking number",
	"trackingHistory": "Tracking history",
	"package": "Package",
	"destination": "Destination",
	"shipmentStatus": "Status",
	"email": "Email",
	"email-format": "Wrong format",
	"email-spell-warning": "Could there be an error in the email did you mean {{email}}",
	"email-undeliverable": "Email is undelivarable or does not exist",
	"email-invalid": "Invalid email",
	"phone": "Phone number",
	"ssn": "Kennitala",
	"search": "Search",
	"address": "Address",
	"country": "Country",
	"changeAddressForPeople": "Move individuals to this address",
	"errorFetchingPostalCodes": "No match for street name: ",
	"errorFetchingPostalCodesInfo": "Only input the street name without numbers and spaces",
	"familyMembers-one-required": "You have to choose at least one individual",
	"street": "Street name",
	"streetNumber": "Street number",
	"appartmentNumber": "Appartment number",
	"additionalInformation": "Additional information",
	"street-required": "Street name is required",
	"streetNumber-required": "Street number is required",
	"zip-required": "Postal code is required",
	"information": "Information",
	"hi": "Hi ",
	"expired": "Expired",
	"active": "Active",
	"filesAdditionalInformation": "Content description",
	"yes": "Yes",
	"no": "No",
	"or": "Or",
	"confirm": "Confirm",
	"submit": "Submit",
	"send": "Send",
	"unknown": "Unknown",
	"change": "Change",
	"more": "More",
	"Click": "Click",
	"here": "here",
	"priceBreakdown": "Cost breakdown",
	"pay": "Pay",
	"payWith": "Pay with",
	"total": "Total",
	"delete": "Delete",
	"deleteItem": "Delete item?",
	"remove": "Remove",
	"save": "Save",
	"seeMore": "See more",
	"seeLess": "See less",
	"enabled": "Enabled",
	"disabled": "Disabled",
	"viewOnMap": "View on map",
	"required": "Required",
	"wrongFormat": "Wrong format",
	"tooShort": "Too few characters",
	"tooLong": "Too many characters",
	"genericError": "Something went wrong, please try again.",
	"genericRegistrationError": "Registration failed.",
	"choose": "Choose",
	"passwordConfirmError": "Passwords do not match",
	"passwordLengthError": "Must be atleast 6 characters",
	"phoneMustBe7": "Phone number must be 7 digits",
	"success": "Success",
	"genericVerificationError": "Verification failed",
	"invalidValue": "Invalid value",
	"qrCode": "QR code",
	"terms": "Terms",
	"acceptTerms": "By filling out this request you grant Pósturinn permission to clear your shipment through Customs.",
	"termsLinked": "I agree with these <0>terms.</0>",
	"availableForDropOff": "Drop off your shipment",
	"errorFetchDocument": "Error fetching document",
	"refunds": {
		"refundAvailable": "According to our systems, you have {{refundAvailable}} kr. available for refund.",
		"refundReceived": "You have received a refund of {{refundCorrected}} kr.",
		"noRefund": "No refund found.",
		"bankInfoSent": "Bank information has been sent.",
		"refundExplanation1": "Unfortunately, Pósturinn encountered a system error from November 16, 2022, to February 23, 2023. Due to the error, some types of foreign shipments were placed in the incorrect price category. You received shipment that fell into the wrong price category. Pósturinn owes you {{refundAvailable}} kr.",
		"refundExplanation2": "You can decide whether to get a refund or put the money towards your next international shipment. If you decide to request a refund, kindly complete the following form before 1st. of October 2023. At the end of this period, the balance will be used for your subsequent international shipment. ",
		"refundApology": "We apologise for the error and the trouble it has caused."
	},
	"showMore": "Show more",
	"cardExpired": "Payment card is not valid",
	"invalidRegTypeUS": "It is not possible to register this shipment to the USA at this time due to upcoming changes by U.S. authorities. ",
	"weight": "Weight"
}